import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";

import HeadSeo from "../components/HeadSeo/HeadSeo";

import siteMetadata from "../data/siteMetadata";

import dynamic from "next/dynamic";
import { checkUser } from "utils/BackendHelper";
import { wrapper } from "redux/configureStore";
import nookies from "nookies";

import useTranslation from "next-translate/useTranslation";

import style from "./style.module.css";

const LoginRegisterDialog = dynamic(
  () => import("components/LoginRegisterDialog"),
  {
    ssr: false,
    suspense: true,
  }
);

export const getServerSideProps = wrapper.getServerSideProps((store) => {
  return async (ctx) => {
    return new Promise<any>(async (resolve, reject) => {
      let user: any = await checkUser(ctx, store, null);
      let recommanded_listings = [];
      const cookies = nookies.get(ctx);
      if (!user) {
        resolve({
          props: {
            checkPro: ctx.query.pro ? true : false,
            resolvedUrl: ctx.resolvedUrl,
          },
        });
      } else {
        if (ctx.query.redirect) {
          resolve({
            redirect: {
              destination: ctx.query.redirect,
              permanent: false,
            },
          });
        } else {
          if (user.isPro) {
            resolve({
              redirect: {
                destination: "/espace-pro",
                permanent: false,
              },
            });
          } else {
            resolve({
              redirect: {
                destination: "/user/estimates",
                permanent: false,
              },
            });
          }
        }
      }
    });
  };
});

const RendringPage = (props) => {
  const [mounted, setMounted] = useState(false);

  const handleRedirect = (user: any) => {
    window.location.href = `/${lang}/${
      user.inscriptionProfessionel &&
      (user.useractivity === "Agent Immobilier" ||
        user.useractivity === "Promoteur / Constructeur")
        ? "/espace-pro/vitrine/gerermavitrine"
        : "/user/estimates"
    }`;
  };
  const handleRedirectSignup = (user: any) => {
    window.location.href = `/${lang}/${
      user.inscriptionProfessionel &&
      (user.useractivity === "Agent Immobilier" ||
        user.useractivity === "Promoteur / Constructeur")
        ? "/espace-pro/vitrine/gerermavitrine?inscription=true"
        : "/user/estimates"
    }`;
  };
  const { lang } = useTranslation("headers");
  return (
    <div className={style.pageRegisterContainer}>
      <HeadSeo
        title={
          lang == "fr"
            ? props.checkPro
              ? `Première plateforme d'estimation immobilière`
              : "Première plateforme d'estimation immobilière"
            : props.checkPro
            ? `أول منصة للتثمين العقاري`
            : "أول منصة للتثمين العقاري"
        }
        description={
          lang == "fr"
            ? props.checkPro
              ? `Déposez gratuitement vos annonces et entrez en contacts avec des porteurs de projets immobiliers sur tout le maroc`
              : "Estimaiton, prix immobiliers, annonces d'appartements et maisons à vendre et à louer"
            : props.checkPro
            ? "انشر إعلاناتك مجانًا وتواصل مع حاملي المشاريع العقارية في جميع أنحاء المغرب"
            : "تقدير, اسعار العقارات, والاعلانات عن شقق ومنازل للبيع والايجار"
        }
        ogImageUrl={
          "https://storage.googleapis.com/headers-agenz/Logo%20300_%20300%20px.jpg"
        }
        ogTwitterImage={siteMetadata.siteLogoSquare}
        ogType={"website"}
        ogTitle={
          lang == "fr"
            ? props.checkPro
              ? `Première plateforme d'estimation immobilière`
              : "Première plateforme d'estimation immobilière"
            : props.checkPro
            ? `أول منصة للتثمين العقاري`
            : "تقدير, اسعار العقارات, والاعلانات عن شقق ومنازل للبيع والايجار"
        }
        ogDescription={
          lang == "fr"
            ? props.checkPro
              ? `Déposez gratuitement vos annonces et entrez en contacts avec des porteurs de projets immobiliers sur tout le maroc`
              : "Estimaiton, prix immobiliers, annonces d'appartements et maisons à vendre et à louer"
            : props.checkPro
            ? "انشر إعلاناتك مجانًا وتواصل مع حاملي المشاريع العقارية في جميع أنحاء المغرب"
            : "تقدير, اسعار العقارات, والاعلانات عن شقق ومنازل للبيع والايجار"
        }
        canonicalUrl={"https://agenz.ma/register"}
        structuredData={false}
      >
        <></>
      </HeadSeo>

      <div className={style.registerPage}>
        <div className={style.leftSide}>
          <LoginRegisterDialog
            visible={false}
            onClose={() => {}}
            onFacebookSignInSuccess={handleRedirect}
            onGoogleSignInSuccess={handleRedirect}
            onRegisterSucccess={handleRedirectSignup}
            onSignInSuccess={handleRedirect}
            onSwitchSignType={() => {
              return;
            }}
            Estimation={true}
            variant="PAGE"
            defaultView="REGISTER"
            checkPro={props.checkPro}
            Register={true}
            registerWithPassword={true}
          />
        </div>
        <div
          className={style.rightSide}
          // style={{
          //   backgroundImage: `url(https://storage.googleapis.com/listings-image/static/estimation-immobiliere_1200x630.webp)`,
          //   back
          // }}
        ></div>
      </div>
    </div>
  );
};

export default RendringPage;
